import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import AuthLayout from "@/components/AuthLayout";
import { t } from "@/lib/i18n";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 6) return setError(t("Password must be at least 6 characters."));
    if (password !== confirm) return setError(t("Passwords do not match."));
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success(t("Password updated — please log in"));
      navigate("/login");
    } catch (err) { setError(errMsg(err)); }
    setBusy(false);
  };

  if (!token) {
    return (
      <AuthLayout title={t("Invalid link")} subtitle={t("This reset link is missing its token.")}>
        <Link to="/forgot-password" className="hf-btn-dark w-full" data-testid="request-new-link-btn">{t("Request a new link")}</Link>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title={t("Choose a new password")} subtitle={t("Pick a password you haven't used before.")}>
      <form onSubmit={submit} className="space-y-5" data-testid="reset-form">
        <div>
          <label className="hf-label">{t("New password")}</label>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="hf-input" data-testid="reset-password-input" />
        </div>
        <div>
          <label className="hf-label">{t("Confirm password")}</label>
          <input type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} className="hf-input" data-testid="reset-confirm-input" />
        </div>
        {error && <p className="text-sm text-red-600" data-testid="reset-error">{error} {error.includes("expired") && <Link to="/forgot-password" className="underline font-semibold">{t("Request a new link")}</Link>}</p>}
        <button disabled={busy} className="hf-btn-dark w-full h-12 text-base" data-testid="reset-submit-btn">{busy ? t("Saving…") : t("Update password")}</button>
      </form>
    </AuthLayout>
  );
}
